import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DevicesStore } from '@store';

@Component({
  selector: 'app-src-settings-overlay',
  templateUrl: './src-settings-overlay.component.html',
  styleUrls: ['./src-settings-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsOverlayComponent implements OnInit {
  gatewaySerial: string;

  constructor(public devicesStore: DevicesStore, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.gatewaySerial = queryParams?.gatewaySerial;
    });
  }
}
